/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Pair
 */
export interface PairDto {
  name: string;
  /**
   * Max supported decimals after dot for quantity fields.
   */
  qtyScale: number;
  /**
   * Max supported decimals after dot for price fields.
   */
  priceScale: number;
  /**
   * Min quantity for order.
   */
  minQty: number;
  /**
   * Max quantity for order.
   */
  maxQty: number;
  /**
   * Min price for limit order.
   */
  minPrice: number;
  /**
   * Max price for limit order.
   */
  maxPrice: number;
  /**
   * Max supported decimals after dot for volume fields.
   */
  volumeScale: number;
}
